import { render } from "./PostContainer.vue?vue&type=template&id=2399d0a7&scoped=true"
import script from "./PostContainer.vue?vue&type=script&lang=js"
export * from "./PostContainer.vue?vue&type=script&lang=js"

import "./PostContainer.vue?vue&type=style&index=0&id=2399d0a7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2399d0a7"

export default script